import type { ContentService, NetworkService, PlansService } from "@/services/ports"
import type { NetworkQuery, NetworkUnit, Plan, PlanComparison, PlanModality, SiteContent } from "@/services/types"
import type { HttpClient } from "@/services/api/httpClient"

/* ─────────────────────────────────────────────────────────────────────────────
 * Adapters da API da BusiPet.
 *
 * ⚠️ Os caminhos abaixo sao PROVISORIOS. A API publica do site institucional
 * ainda nao existe; quando existir, o que muda e este arquivo — os caminhos e,
 * se necessario, uma funcao de mapeamento entre o payload e o modelo de
 * dominio. Nenhum componente e tocado.
 *
 * Enquanto isso, `VITE_DATA_SOURCE` fica em "static" e nada aqui roda. O codigo
 * existe para que a migracao seja uma troca de adapter, e nao uma reforma da
 * arvore de componentes.
 *
 * Quando os endpoints forem definidos, confira dois pontos antes de ligar:
 *   1. CORS liberado para https://dimpetrn.com.br — o site e outra origem.
 *   2. Cache na borda. Conteudo institucional muda raramente e nao deveria
 *      gerar uma chamada de API por visita.
 * ────────────────────────────────────────────────────────────────────────── */

const PATHS = {
  plans: "/v1/institucional/planos",
  comparison: "/v1/institucional/planos/comparativo",
  networkUnits: "/v1/institucional/rede/unidades",
  coveredStates: "/v1/institucional/rede/estados",
  siteContent: "/v1/institucional/conteudo",
} as const

export function createApiPlansService(http: HttpClient): PlansService {
  return {
    listPlans: (modality: PlanModality) => http.get<Plan[]>(PATHS.plans, { modalidade: modality }),

    getComparison: (modality: PlanModality) =>
      http.get<PlanComparison>(PATHS.comparison, { modalidade: modality }),
  }
}

export function createApiNetworkService(http: HttpClient): NetworkService {
  return {
    // O filtro vira querystring: a partir daqui quem seleciona e o servidor, e
    // o navegador para de baixar a rede inteira para exibir tres unidades.
    searchUnits: (query: NetworkQuery) =>
      http.get<NetworkUnit[]>(PATHS.networkUnits, {
        cep: query.postalCode,
        uf: query.state,
        cidade: query.city,
      }),

    listCoveredStates: () => http.get<string[]>(PATHS.coveredStates),
  }
}

export function createApiContentService(http: HttpClient): ContentService {
  return {
    getSiteContent: () => http.get<SiteContent>(PATHS.siteContent),
  }
}
